export interface PromoPhase {
	name: string;
	startDate: Date;
	endDate: Date;
	discountPercentage: number;
}

export const PROMO_PHASES: PromoPhase[] = [
	{
		name: 'Regularización Fiscal 2025 - 50%',
		startDate: new Date('2026-01-26T00:00:00-06:00'),
		endDate: new Date('2026-01-31T23:59:59-06:00'),
		discountPercentage: 0.5,
	},
];

export const PROMO_CONFIG = {
	startDate: PROMO_PHASES[0].startDate,
	endDate: PROMO_PHASES[PROMO_PHASES.length - 1].endDate,
	prePromoThresholdDays: 0,
	postPromoThresholdDays: 0,
};

export type PromoCategoryType =
	| 'regularizations'
	| 'monthly_declarations'
	| 'annual_declarations'
	| 'asat'
	| 'invoicing';

export const PROMO_DISCOUNT_CONFIG: Record<
	PromoCategoryType,
	{ activePromo: boolean }
> = {
	regularizations: { activePromo: true },
	monthly_declarations: { activePromo: false },
	annual_declarations: { activePromo: false },
	asat: { activePromo: false },
	invoicing: { activePromo: false },
};
